module.exports = __webpack_public_path__ + "static/media/whats.fb568bdb.svg";